<div class="custom-dropdown" #dropdown>
  @if (facing === 'DOWN') {
    <div class="selected-option" (click)="toggleDropdown()">{{ placeholder }}</div>
  }
  @if (isOpen) {
    <div [class]="facing === 'UP' ? 'options-list facing-up' : 'options-list'">
      @for (optionColumn of groupedOptions; track optionColumn) {
        <ul class="dropdown-list" >
          @for (option of optionColumn; track option) {
            <li (click)="selectOption(option)">{{ option.name }}</li>
          }
        </ul>
      }
    </div>
  }
  @if (facing === 'UP') {
    <div class="selected-option" (click)="toggleDropdown()">{{ placeholder }}</div>
  }
</div>
